module.exports = __webpack_public_path__ + "df2b9945d4d3d63c92861a7dc0a98942.svg";